import * as yup from "yup";
import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

var requestSchema = yup.object({
  patientId: yup.number().required(),
});

var responseSchema = yup.array().of(
  yup.object({
    id: yup.string().required(),
    cardNumber: yup.string().required(),
    type: yup.string().required(),
    card: yup
      .object({
        brand: yup.string().required(),
        last4: yup.string().required(),
        expire_date: yup.string().required(),
        email: yup.string().nullable(),
      })
      .required(),
    is_primary: yup.boolean().required(),
  }),
);

var composeResponse = (res) => {
  var data = res?.data?.data?.paymentMethods || [];

  return data.map((x) => {
    const last4 = `ending with ${x.card.last4}`;
    return {
      ...x,
      cardNumber:
        x.type === "card"
          ? `${x.card.brand} ${last4}`
          : `${x.card.brand} - ${x.card.email}`,
      is_primary: Boolean(x.is_primary),
    };
  });
};

export function useStripePaymentMethodsQuery(payload, options = {}) {
  return useQuery(
    [QUERY_KEYS.stripe.paymentMethods, payload.patientId],
    async () => {
      const req = requestSchema.validateSync(payload, {
        strict: true,
      });
      const res = await http.post(HTTP_ENDPOINTS.stripe.getPaymentMethods(), {
        patient_id: req.patientId,
      });
      return responseSchema.validateSync(composeResponse(res), {
        strict: true,
      });
    },
    options,
  );
}
